import React, { useState, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useUser } from '../../context/UserContext';
import AdminSidebar from '../../components/admin/AdminSidebar';
import AdminNavbar from '../../components/admin/AdminNavbar';
import './admin.css';

const AdminLayout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { user, isAuthenticated, loading } = useUser();

  // Authentication & Authorization check
  useEffect(() => {
    if (loading) return;
    
    if (!isAuthenticated || user?.role !== 'admin') {
      navigate('/admin/login');
    }
  }, [isAuthenticated, user, loading, navigate]);

  useEffect(() => {
    // Add admin-mode class to body for global fonts
    document.body.classList.add('admin-mode');
    return () => document.body.classList.remove('admin-mode');
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  if (loading) {
     return (
        <div style={{ minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#f8fafc' }}>
            <div className="spinner-border" style={{ color: '#10b981' }} role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
     );
  }

  if (!isAuthenticated || user?.role !== 'admin') {
    return null; // Will redirect via the useEffect
  }

  return (
    <div className="admin-layout">
      {/* Mobile Sidebar Overlay */}
      <div 
        className={`sidebar-overlay ${mobileMenuOpen ? 'active' : ''}`}
        onClick={() => setMobileMenuOpen(false)}
      ></div>

      <AdminSidebar 
        collapsed={sidebarCollapsed}
        mobileOpen={mobileMenuOpen}
        onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
      />

      <div className="admin-main">
        <AdminNavbar 
          onToggleMobile={() => setMobileMenuOpen(true)} 
        />
        <main className="admin-content-wrapper">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;